import { __rest } from 'tslib';
import React from 'react';
import Link from 'next/link';

const MobileLink = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    if (!props.href)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(Link, Object.assign({}, props), children);
};

export { MobileLink as M };
